import { useSelector } from "react-redux";
import { FunctionDefinition } from "./types";

export const useFunctionDefinitionValidator = () => {
  const { functionDefs: allFunctionDefs } = useSelector(
    (state) => (state as any).functionDefs
  );

  return (functionDef: FunctionDefinition) => {
    if (!functionDef.type) {
      return new Error(
        "Function must be specified as either 'Source' or 'Destination'"
      );
    }

    if (functionDef.name.length == 0) {
      return new Error("Function must have a name");
    }

    if (!isValidURL(functionDef.source)) {
      return new Error(
        "Function source must be a valid GitHub URL starting with 'http'"
      );
    }

    if (
      allFunctionDefs.find(
        (otherFunctionDef: FunctionDefinition) =>
          otherFunctionDef.name === functionDef.name &&
          otherFunctionDef.type === functionDef.type &&
          otherFunctionDef.id !== functionDef.id
      )
    ) {
      return new Error(
        "Function has the same name as another function of the same type"
      );
    }
  };
};

const isValidURL = (urlString: string): boolean => {
  let sourceURL;
  try {
    sourceURL = new URL(urlString);
  } catch (_) {
    return false;
  }

  if (sourceURL.hostname !== "github.com") {
    return false;
  }

  return sourceURL.protocol === "http:" || sourceURL.protocol === "https:";
};
